export default "__VITE_ASSET__C5sv7UIS__"